import * as React from 'react';
import {emptyObject} from '@packages/utilities/fp/utils';
import type {ButtonProps} from './Button';

export type ButtonGroupContextProps = {
  /**
   * The color of the buttons. Combine with `variant` to achieve your intended style.
   */
  colorVariant?: ButtonProps['colorVariant'];
  /**
   * Props for truncating text within any child `Button` components (but not `IconButton` components).
   */
  truncationProps?: ButtonProps['truncationProps'];
  /**
   * The variant of the buttons. Combine with `colorVariant` to achieve your intended style.
   */
  variant?: Exclude<ButtonProps['variant'], 'ghost'>;
};

export const ButtonGroupContext = React.createContext<ButtonGroupContextProps>({
  colorVariant: 'default',
  truncationProps: emptyObject,
  variant: 'solid',
});

export const useButtonGroupContext = () => React.useContext(ButtonGroupContext);
